const Home = () => {
  return (
    <>
      <div>Home</div>
    </>
  );
};

export default Home;
